




import {Component, Vue} from 'vue-property-decorator';

import {Enum}                        from '@/app/shared/enum/enum';
import {broadcast}                   from '@/core/service/broadcast.service';
import ServiceAgreeModal             from '@/app/shared/components/modal/service-agree.modal.vue';
import PersonalInformationAgreeModal from '@/app/shared/components/modal/personal-information-agree.modal.vue';
import GeniePersonalInformationModal from '@/app/shared/components/modal/genie-personal-information.modal.vue';
import MaketingInformationAgreeModal from '@/app/shared/components/modal/maketing-information-agree.modal.vue';
import ServiceAgreeFooterModal       from '@/app/shared/components/modal/service-agree-footer.modal.vue';

@Component
export default class NAgreeModal extends Vue {
  modal: any = null;

  mounted() {
    broadcast.$on(this.$enum.CORE.MODAL.MODAL_OPEN, this.onModalOpen);
  }

  beforeDestroy() {
    broadcast.$off(this.$enum.CORE.MODAL.MODAL_OPEN, this.onModalOpen);
  }

  onModalOpen(modal: Enum.CORE.MODAL) {
    switch (modal) {
      case this.$enum.CORE.MODAL.SERVICE_AGREE:
        this.openModal(ServiceAgreeModal);
        break;
      case this.$enum.CORE.MODAL.SERVICE_AGREE_FOOTER:
        this.openModal(ServiceAgreeFooterModal);
        break;
      case this.$enum.CORE.MODAL.PERSONAL_INFORMATION_AGREE:
        this.openModal(PersonalInformationAgreeModal);
        break;

      case this.$enum.CORE.MODAL.GENIE_PERSONAL_INFORMATION:
        this.openModal(GeniePersonalInformationModal);
        break;

      case this.$enum.CORE.MODAL.MARKETING_INFORMATION_AGREE:
        this.openModal(MaketingInformationAgreeModal);
        break;
    }
  }

  onServiceAgreeYn(serviceAgreeYn) {
    this.$emit('onServiceAgreeYn', serviceAgreeYn);
  }

  onPersonalInfomationAgreeYn(personalInfomationAgreeYn) {
    this.$emit('onPersonalInfomationAgreeYn', personalInfomationAgreeYn);
  }

  onMaketingAgreeYn(maketingAgreeYn) {
    this.$emit('onMaketingAgreeYn', maketingAgreeYn);
  }

  async openModal(component: any) {
    this.modal = await component;
  }
}
